<template>
  <page>
    <div>
      <v-card>
        <v-card-text>
          <form>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-expansion-panels v-model="panel1" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-lg>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-radio-group class="d-flex" v-model="form.selectedType" :mandatory="true" @change="doSelect($event)">
                                    <v-row no-gutters>
                                      <v-col class="pa-2" cols="12" lg="4" md="4" sm="12">
                                        <v-radio :label="label.clmNo" value="clmNo"></v-radio>
                                      </v-col>
                                      <v-col class="pa-2" cols="12" lg="8" md="8" sm="12" v-if="form.selectedType === 'clmNo'">
                                        <v-text-field
                                          v-model="form.claimNo"
                                          :label="label.claimNo"
                                          :error-messages="errors.collect('claimNo')"
                                          data-vv-name="claimNo"
                                          :data-vv-as="label.claimNo"
                                          v-validate="validateClmNo"
                                        >
                                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                            <v-icon color="info" @click="showClmHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                          </v-slide-x-reverse-transition>
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                      <v-col class="pa-2" cols="12" lg="4" md="4" sm="12">
                                        <v-radio :label="label.polNo" value="polNo"></v-radio>
                                      </v-col>
                                      <v-col class="pa-2" cols="12" lg="4" md="4" sm="12" v-if="form.selectedType === 'polNo'">
                                        <v-text-field
                                          v-model="form.policyNo"
                                          :label="label.policyNo"
                                          :error-messages="errors.collect('policyNo')"
                                          data-vv-name="policyNo"
                                          :data-vv-as="label.policyNo"
                                          v-validate="validatePolNo"
                                        >
                                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                            <v-icon color="info" @click="showPolicyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                          </v-slide-x-reverse-transition>
                                        </v-text-field>
                                      </v-col>
                                      <v-col class="pa-2" cols="12" lg="4" md="4" sm="12" v-if="form.selectedType === 'polNo'">
                                        <v-text-field
                                          v-model="form.renCnt"
                                          :label="label.renCnt"
                                          :error-messages="errors.collect('renCnt')"
                                          data-vv-name="renCnt"
                                          :data-vv-as="label.renCnt"
                                          v-validate="'entry'"
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <v-expansion-panels class="mt-2" v-model="panel2" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-lg>
                              <v-layout row wrap>
                                <v-flex xs6>
                                  <cal-picker
                                    v-model="form.entryDateFrom"
                                    :label="label.entryDateFrom"
                                    :data-vv-as="label.entryDateFrom"
                                    data-vv-name="form.entryDateFrom"
                                    :error-messages="errors.collect('form.entryDateFrom')"
                                    v-validate="'required'"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs6>
                                  <cal-picker
                                    v-model="form.entryDateTo"
                                    :label="label.entryDateTo"
                                    :data-vv-as="label.entryDateTo"
                                    data-vv-name="form.entryDateTo"
                                    :error-messages="errors.collect('form.entryDateTo')"
                                    v-validate="entryDateToValidation"
                                  ></cal-picker>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
                <v-icon left dark>mdi-file-export</v-icon>
                {{ label.export }}
              </v-btn>
              <v-btn-toggle dense mandatory v-model="form.format">
                <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                  <span>{{ format.label }}</span>
                  <v-icon :color="format.color">{{ format.icon }}</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-card-actions>
          </form>
        </v-card-text>
      </v-card>
    </div>

    <v-dialog v-model="showClmHelpList" width="1280px">
      <claim-help-list @close="showClmHelpList = false" :apiURI="this.specialMenu.claimList" @assign-claim="assignClaimInfo"></claim-help-list>
    </v-dialog>

    <v-dialog v-model="showPolicyHelpList" width="1280px">
      <policy-help-list
        @close="showPolicyHelpList = false"
        :apiURI="this.specialMenu.policyList"
        @assign-policy="assignPolicyInfo"
      ></policy-help-list>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import ClaimHelpList from '@/components/reports/specialReports/ClaimHelpList'
import PolicyHelpList from '@/components/reports/specialReports/PolicyHelpList'

export default {
  data() {
    return {
      form: {
        selectedType: undefined,
        claimNo: null,
        policyNo: null,
        renCnt: null,
        entryDateFrom: null,
        entryDateTo: null,
        format: undefined
      },
      label: {
        clmNo: 'Claim No.',
        claimNo: 'Claim No.',
        polNo: 'Policy No.',
        policyNo: 'Policy No.',
        renCnt: 'Renewal Count',
        entryDateFrom: 'From Entry Date',
        entryDateTo: 'To Entry Date',
        format: 'Export Format',
        export: 'Export to'
      },
      showClmHelpList: false,
      showPolicyHelpList: false,
      menu: {},
      supportedFormat: [],
      loading: false,
      validatePolNo: '',
      validateClmNo: '',
      panel1: [0],
      panel2: []
    }
  },
  methods: {
    async doInit() {
      this.doSelect('polNo')
      try {
        if (this.$store.state.reports.specialReports.init !== 1) {
          await this.$store.dispatch('specialReportsInit')
        }
        const apiURI = this.specialMenu.customerLogHistory
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doSelect(data) {
      if (data === 'clmNo') {
        this.form.policyNo = null
        this.form.renCnt = null
        this.validatePolNo = ''
        this.validateClmNo = 'required'
        this.form.entryDateFrom = null
        this.form.entryDateTo = null
      } else {
        this.form.claimNo = null
        this.validatePolNo = 'required'
        this.validateClmNo = ''
        this.form.entryDateFrom = null
        this.form.entryDateTo = null
      }
      this.form.selectedType = data
      this.resetMessages()
      this.resetValidator()
    },
    doExport() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignClaimInfo(data) {
      this.form.claimNo = data.clmNo
    },
    assignPolicyInfo(data) {
      this.form.policyNo = data.polNo
      this.form.renCnt = data.renCnt
    }
  },
  computed: {
    specialMenu() {
      return this.$store.state.reports.specialReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    entryDateToValidation() {
      if (this.form.entryDateTo !== '' && this.form.entryDateTo !== null) {
        return 'entry|valEntryDateTo:' + this.form.entryDateFrom
      } else {
        return 'required'
      }
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('valEntryDateTo', {
      getMessage(field, args) {
        return 'Entry Date To must be equal or greater than Entry Date From'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var entryDateTo = args[0]
        if (entryDateTo) {
          return !isAfter(removeTime(entryDateTo), removeTime(value))
        }
      }
    })
  },
  watch: {},
  mixins: [MessageMixin],
  components: {
    ClaimHelpList,
    PolicyHelpList
  }
}
</script>
